import React from "react";
import SectionContentBox from "../SectionContentBox";
import RatingSlider from "./ratingSlider/RatingSlider";
import {useLanguage} from "../../hooks/LanguageContext";

const Ratings = () => {
	const { direction } = useLanguage(); // Get the direction from LanguageContext

	return (
		<section className={`container mt-[100px] ${direction === "rtl" ? "text-right" : "text-left"}`}>
			<SectionContentBox
				width="w-full"
				align={"items-start"}
				title={direction === "ltr" ? "Ratings" : "التقييمات"}
				hideBtn={true}
				hasTowLines={false}
				headline={
					<>
						{direction === "ltr" ? "What Our" : "ماذا يقول"}{" "}
						<span className="text-primary-700">
              {direction === "ltr" ? "Customers" : "عملاؤنا"}
            </span>{" "}
						{direction === "ltr" ? "Say About Us" : "عنا"}
					</>
				}
				paragraph={
					direction === "ltr"
						? "Real experiences and honest feedback. Discover why our customers trust Al-Fayez Group for their vehicle transport needs."
						: "تجارب حقيقية وردود فعل صادقة. اكتشف لماذا يثق عملاؤنا في مجموعة الفايز في احتياجاتهم من نقل المركبات."
				}
				buttonText={direction === "ltr" ? "See More" : "المزيد"}
			/>
			<RatingSlider />
		</section>
	);
};

export default Ratings;
